<ng-content></ng-content>

<div class="table-container">
  <table
    mat-table
    matSort
    [dataSource]="dataSource"
    class="digital-platform-sort-icon mat-elevation-z8"
  >
    <!-- Date -->
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="date">
        Date
        <digital-platform-sort-icon
          [direction]="sort.active === 'date' ? sort.direction : ''"
        ></digital-platform-sort-icon>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.date | date: dateFormat }}
      </td>
    </ng-container>

    <!-- Type -->
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="type">
        Type
        <digital-platform-sort-icon
          [direction]="sort.active === 'yupe' ? sort.direction : ''"
        ></digital-platform-sort-icon>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.type?.replace('-', ' ') || '-' | titlecase }}
      </td>
    </ng-container>

    <!--  user -->
    <ng-container matColumnDef="userName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="userName">
        User
        <digital-platform-sort-icon
          [direction]="sort.active === 'userName' ? sort.direction : ''"
        ></digital-platform-sort-icon>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.userName }}
      </td>
    </ng-container>

    <!--  internalStatus -->
    <ng-container matColumnDef="internalStatus">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="internalStatus">
        Internal Status
        <digital-platform-sort-icon
          [direction]="sort.active === 'internalStatus' ? sort.direction : ''"
        ></digital-platform-sort-icon>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.internalStatus }}
      </td>
    </ng-container>

    <!-- Status-->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="status">
        Customer Status
        <digital-platform-sort-icon
          [direction]="sort.active === 'status' ? sort.direction : ''"
        ></digital-platform-sort-icon>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.status }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>

<div
  class="no-results"
  *ngIf="wasteProfile && (!wasteProfile.log || wasteProfile.log.length === 0)"
>
  <img src="/assets/figure-no-results.svg" width="208px" />
  No Search Results.
</div>
